
import React from 'react';
import { Anchor, Box, Text } from 'grommet';
import { Checkmark } from 'grommet-icons';

const LayerDescriptionLink = ({markdown}) => {
    return (
        <Box pad={{top: '2px', right: '16px'}} direction="row">
            <Text size="small">(</Text>
            <Anchor href={`#/link_${markdown}`} label="popis" />
            <Text size="small">)</Text>
        </Box>
    );
}

const LayerItem = ({layer, onClick}) => {
    const handleClick = () => {
        if (onClick) {
            onClick(layer.id, !layer.visible);
        }
    }

    const color = layer.visible ? '' : 'status-disabled';
    const status = layer.visible ? <Checkmark /> : null;

    return (
        <Box direction="row">
            <Box direction="row" flex="grow" pad={{left: '12px', bottom: '4px'}} onClick={handleClick} style={{cursor: 'pointer'}}>
                <Box basis="32px">
                    {status}
                </Box>
                <Text
                    color={color}
                >{layer.title}
                </Text>
            </Box>
            {layer.markdown
                ? <LayerDescriptionLink markdown={layer.markdown} />
                : null
            }
        </Box>
    );
}

const Layers = ({layers, onClick}) => {
    return layers.map(item => {
        return (
            <LayerItem
                key={item.id}
                onClick={onClick}
                layer={item}
            />
        );
    });
}

const LayerGroup = ({layers, group, onClick}) => {
    return (
        <Box pad={{bottom: '16px'}}>
            <Box direction="row" pad={{left: '12px', bottom: '4px'}}>
                <Text
                    color="dark-3"
                    size="xxsmall"
                >{group.title}
                </Text>
            </Box>
            <Layers
                layers={layers.filter(item => {
                    return (group.layers.indexOf(item.id) !== -1);
                })}
                onClick={onClick}
            />
        </Box>
    );
}

const LayerGroups = ({layers, groups, onClick}) => {
    return groups.map(group => {
        return (
            <LayerGroup
                key={group.id}
                layers={layers}
                group={group}
                onClick={onClick}
            />
        );
    });
}

const LayersPanel = ({layers, groups, setLayerVisibility}) => {
    return (
        <Box height="100%">
            <LayerGroups
                groups={groups}
                layers={layers}
                onClick={setLayerVisibility}
            />
        </Box>
    );
}

export default LayersPanel;
